/* unplugin-vue-components disabled */import script from "./schoolMes_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./schoolMes_copy.vue?vue&type=script&setup=true&lang=js"

import "./schoolMes_copy.vue?vue&type=style&index=0&id=3301568f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3301568f"]])

export default __exports__